// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610092241/js/" + chunkId + "." + {"44":"333676c9","225":"4441829a","481":"65370454","486":"b6e1c949","770":"4fa51186"}[chunkId] + ".0.1947206506229756.chunk.js";
};